import axiosNode from "@/plugins/axios_node";
export default {
  namespaced: true,
  state: {
    list_strategy_type: null,
    list_school: [],
  },
  getters: {
    _list_strategy_type: (state) => state.list_strategy_type,
    list_school: (state) => state.list_school,
  },
  mutations: {},
  actions: {
    _list_strategy_type({ state }, params) {
      return axiosNode
        .post("project/_list_strategy_type", params)
        .then((res) => (state.listSchool_UserAll = res.data));
    },
    list_school({ state }, params) {
      return axiosNode.get("website/list_school", params).then((res) => {
        state.list_school = res.data;
      });
    },
  },
};
